import { ReactComponent as Folder } from 'assets/icons/folder.svg';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useNavigate } from 'react-router-dom';

const HeaderComponent = () => {
    const navigate = useNavigate();

    const redirectToCU01202 = () => {
        navigate(PRIVATE_ROUTES.PATH + '/' + PRIVATE_ROUTES.SUB.CU_012_02);
    };

    return (
        <>
            <div
                style={{
                    borderRight: '1px solid #192F51',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                メッセージ
                <div>
                    <Folder
                        style={{
                            margin: '1px',
                            width: 22,
                            height: 22,
                        }}
                        onClick={redirectToCU01202}
                        className="cursor_pointer"
                    />
                </div>
            </div>
        </>
    );
};

export default HeaderComponent;
